import Stage2Player4Room from "../shared/Stage2Player4Room";

export default function Four_Players_Stage2_Player4(props) {
  return <Stage2Player4Room {...props} playerCount={4} />;
}
